export default __webpack_public_path__ + "static/media/object--trash-can.4ba13bc2.png";